module.exports = __webpack_public_path__ + "assets/b70c4f080af52bab1d85db024a71b634.png";